import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import { newFetch, GET } from "../../helpers/fetch";

const Events = ({ history, sites }) => {
  const [events, setEvents] = useState([]);

  const activeSite = localStorage.getItem("default_site_id")
      ? Number(localStorage.getItem("default_site_id"))
      : null;
  const [defaultSiteData, setDefaultSiteData] = React.useState(null);
  const defaultSiteHandler = () =>
    setDefaultSiteData(sites.find((site) => site.id === activeSite));

  const fetchEvents = async () => {
    let api_path = "/event";
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let eventsData = response.data;

      // get monthYears
      let monthYears = [
        ...new Set(
          eventsData.map((event) => moment(event.date).format("MMMM YYYY"))
        ),
      ].sort((a, b) => moment(b, "MMMM YYYY") - moment(a, "MMMM YYYY"));

      let eventsByMonthYear = monthYears.map((monthYear) => ({
        monthYear,
        events: eventsData
          .filter(
            (event) => moment(event.date).format("MMMM YYYY") === monthYear
          )
          .sort((a, b) => moment(b.date) - moment(a.date)),
      }));

      setEvents(eventsByMonthYear);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  React.useEffect(() => {
    sites && defaultSiteHandler();
  }, [sites]);

  return (
    <div className="container pt-4 d-flex flex-column">
      <div className="rounded-0 mb-0 dashboard__jumbotron-container preferred__label-container">
          <div className="preferred__label-wrapper">
            <div>
              <i
                className="fas fa-arrow-left"
                style={{
                  marginTop: 5,
                }}
                onClick={() => {
                  history.goBack();
                }}
              />
            </div>
            <div
              style={{
                marginLeft: 20,
              }}
            >
              <h4 className="text-brand">Events</h4>
            </div>
          </div>
        </div>
      <div className="container pt-4">
        {events &&
          events.map((month) => (
            <div key={`month-${month.monthYear}`}>
              <div className="border-bottom">
                <h6 className="pt-4 text-muted">{month.monthYear}</h6>
              </div>
              {month.events.map((event) => (
                <div
                  className="border-bottom bg-white"
                  onClick={() => history.push(`/events/event/${event.id}`)}
                  key={`event-${event.id}`}
                >
                  <div className="d-flex">
                    <div style={{ minWidth: "70px" }}>
                      <div className="d-flex flex-column justify-content-center align-items-center text-center shadow rounded bg-white m-2 p-1">
                        <div
                          className="text-brand font-weight-bold"
                          style={{ fontSize: "1.2rem" }}
                        >
                          {moment(event.date).format("DD")}
                        </div>
                        <div
                          className="text-muted"
                          style={{ fontSize: "0.8rem" }}
                        >
                          {moment(event.date).format("MMM")}
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 d-flex flex-column m-2 p-1">
                      <div className="font-weight-bold mb-1">{event.title}</div>
                      <small className="text-muted w-100">
                        {_.truncate(event.description, { length: 38 })}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export default withRouter(Events);
